import UIHelper from '../../UIHelper';
export const getStatusItemStyle = (systemStatusMessageInfo) => {
    var _a;
    const background = UIHelper.getColorByMessageType((_a = systemStatusMessageInfo === null || systemStatusMessageInfo === void 0 ? void 0 : systemStatusMessageInfo.statusType) !== null && _a !== void 0 ? _a : 'Success');
    const color = systemStatusMessageInfo
        ? UIHelper.getButtonTextColourForMessageType(systemStatusMessageInfo.statusType)
        : 'var(--ab-color-text-on-primary)';
    return {
        background,
        color,
    };
};
